// extracted by mini-css-extract-plugin
export var actions = "_18-0";
export var actionsContainer = "_18-7";
export var border = "_18-1";
export var childFullHeight = "_18-e";
export var collapse = "_18-2";
export var content = "_18-9";
export var contentChild = "_18-d";
export var fullscreen = "_18-b";
export var hasLeftRadius = "_18-j";
export var headerContainer = "_18-3";
export var headerRow = "_18-5";
export var hidePadding = "_18-a";
export var navCollapsedGap = "_18-k";
export var noScrollX = "_18-l";
export var noScrollY = "_18-m";
export var noTopPadding = "_18-h";
export var optOutTopPadding = "_18-c";
export var pageMain = "_18-i";
export var pageOuter = "_18-f";
export var pagePadding = "_18-8";
export var profile = "_18-n";
export var profileContainer = "_18-o";
export var profileImage = "_18-p";
export var profileMain = "_18-q";
export var profileSubtitle = "_18-s";
export var profileTitle = "_18-r";
export var showLeftPadding = "_18-g";
export var tabsPortalSlot = "_18-6";
export var tabsWrapper = "_18-4";
export var title = "_18-t";